import { Button, Link, Stack } from "@mui/material";
import { useState } from "react";
import type { Course, Store } from "../api/ApiData";
import { useApiContext } from "../api/ApiProvider";
import { ColorHexCodes } from "../util/Color";
import Time from "../util/Time";
import ReservationSummary from "./ReservationSummary";
import { StyledText } from "./StyledText";
import { useYesNoDialog, type useYesNoDialogArgs } from "./YesNoDialog";

export default function CancellableReservationSummary({ data }: { data: { rid: string; store: Store; nominated_staff_name: string | undefined; course: Course; date: number; name: string; phone: string; mail: string; request: string } }) {
  const { api } = useApiContext();
  const [isCancelled, setIsCancelled] = useState(false);
  const cancelDialog = useYesNoDialog();
  let cancelMessage = <></>;
  let cancellable = true;
  let showCancelButton = true;

  const currentTime = Time.Now().getTime();
  const cancelDialogParam: useYesNoDialogArgs = {
    onSubmit: (e) => {
      if (e) {
        api.cancelReservation(data.rid).then((statusData) => setIsCancelled(statusData != null));
      }
    },
    text: "本当にキャンセルしますか？キャンセル料金は発生しません。",
    title: "予約キャンセル確認",
  };

  if (data.store) {
    if (isCancelled) {
      cancelMessage = (
        <Stack>
          <StyledText textStyle="CancelText">{"予約はキャンセルされました。"}</StyledText>
          <Stack direction="row">
            <StyledText textStyle="CancelText">再予約を行う場合は</StyledText>
            <Link color={`#${ColorHexCodes.Blue}`} href={`/reserve/?shop=${data.store.id}&course=${data.course.id}`}>
              こちら
            </Link>
            <StyledText textStyle="CancelText">から</StyledText>
          </Stack>
        </Stack>
      );
      cancellable = false;
    } else if (data.store.cancel_grace > 0 && currentTime < data.date) {
      const cancelableHour = Math.ceil(data.store.cancel_grace / Time.AnHour);
      cancelMessage = <StyledText textStyle="CancelText">{`施術開始時刻の${cancelableHour}時間前までキャンセル可能です。`}</StyledText>;
      cancellable = currentTime + data.store.cancel_grace < data.date;
    } else {
      cancelMessage = <StyledText textStyle="CancelText">{"この予約はキャンセルできません。"}</StyledText>;
      showCancelButton = false;
    }
  }

  return (
    <Stack gap={1}>
      <ReservationSummary data={data} />
      <div style={{ background: `#${ColorHexCodes.MainColorGreen}`, height: 1, width: "100%" }} />
      {cancelMessage}
      <Stack alignItems="center" display={showCancelButton ? "" : "none"}>
        <Button color="error" disabled={!cancellable} onClick={() => cancelDialog.show(cancelDialogParam)} sx={{ minHeight: "40px", minWidth: "150px", width: "30%" }} variant="contained">
          予約をキャンセル
        </Button>
      </Stack>
      {cancelDialog.dialog}
    </Stack>
  );
}
